var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiwaliLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_24255",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17750",
    "data-name": "Group 17750",
    transform: "translate(7 7.778)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24254",
    "data-name": "Ellipse 24254",
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    transform: "translate(0 0.222)",
    fill: "#fff",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7, -7.78)",
    filter: "url(#Ellipse_24255)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24255-2",
    "data-name": "Ellipse 24255",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(21 21)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17717",
    "data-name": "Group 17717",
    transform: "translate(71.012 69.299) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96472",
    "data-name": "Path 96472",
    d: "M0,34.088l6.482-7.217c5.475-5.972,5.475-13.682.006-19.647L6.373,7.1,0,0,36.8,17.044ZM13.163,10.416a17,17,0,0,1,0,13.256l14.312-6.629Z",
    fill: "#d20814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiwaliLeftArrow);
export default __webpack_public_path__ + "static/media/diwali-left-arrow.9a45daf86a67d21f01e092d84561c7af.svg";
export { ForwardRef as ReactComponent };